// @flow
import React from 'react'
import PropTypes from 'prop-types'
import './loading.scss'

export default function Loading(props) {
  const { color, size } = props
  const sizeStyle = {
    width: size ? `${size / 3.75}vw` : '',
    height: size ? `${size / 3.75}vw` : ''
  }
  const colorStyle = {
    border: color ? `1px solid ${color}` : '',
    borderColor: color ? `${color} transparent transparent transparent` : ''
  }
  const ringStyle = { ...colorStyle, ...sizeStyle }

  return (
    <div className="loading" style={sizeStyle}>
      <div className="loading__ring" style={ringStyle} />
      <div className="loading__ring" style={ringStyle} />
      <div className="loading__ring" style={ringStyle} />
    </div>
  )
}

Loading.defaultProps = {
  size: 0,
  color: ''
}

Loading.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
